import {Button, Col, Divider, Row, Select, Table, Tabs, Tooltip, Typography} from "antd";
import React, {useCallback, useEffect, useState} from "react";
import {useDispatch, useSelector} from "react-redux";
import {selectStore} from "../../../store/selector";
import {StyledEducationOrdersContainer, StyledRow} from "./index.styles";
import {
  fetchCollegeListToTransferAction,
  fetchGeneralContestAction,
  fetchGeneralContestSpecialitiesListAction,
  fetchGeneralContestSpecialitiesListActionResets,
  fetchGeneralContestWithQuotesAction
} from "../../../store/pages/admission/actions";
import dayjs from "dayjs";
import {IconAccept, IconDiod, IconReject, IconTransferWaiting} from "../../../assets";
import {StyledButton} from "../AdmissionWithoutRanking/index.styles";
import {AcceptModal, MyBreadcrumb, RejectModal, TargetGrantModal, TransferModal} from "../../../components";
import {useSearchParams} from "react-router-dom";
import {useTranslation} from "react-i18next";


export const EducationOrders = () => {
  const dispatch = useDispatch();
  const [searchParams] = useSearchParams();
  const {t} = useTranslation(["educationOrders", "admission"])

  const [currentTargetGrantPagination, setCurrentTargetGrantPagination] = useState(1)

  const [currentTab, setCurrentTab] = useState("")

  const redirect = searchParams.get("redirect")

  const {admission: {specialities, generalContest, generalContestWithQuotes}} = useSelector(selectStore);

  const baseStudyState = [
    {
      value: "1", name: t("educationOrders:basicSecondary")
    },
    {
      value: "2", name: t("educationOrders:fullSecondary")
    },
    {
      value: "4",
      name: t("educationOrders:tipo")
    }
  ]

  let initialFilterChange = {
    baseStudy: null,
    speciality: null,
    qualification: null,
    specialityIndex: null
  }

  let initialModalState = {
    accept: false,
    reject: false,
    transfer: false,
    targetGrant: false
  }

  const [filterChange, setFilterChange] = React.useState(initialFilterChange)

  const [modalState, setModalState] = React.useState(initialModalState)

  //main state
  const [data, setData] = React.useState({})


  const handleModalVisible = (value: any, key: any, record: any) => {
    setModalState(prev => ({
      ...prev,
      [key]: value
    }))

    setData(record)
  }

  const handleCallGeneralContest = () => {
    const data = {
      base_education: filterChange.baseStudy,
      speciality_id: filterChange.speciality
    }

    //@ts-ignore
    dispatch(fetchGeneralContestAction(data))
    //@ts-ignore
    dispatch(fetchGeneralContestWithQuotesAction(data))
  }

  useEffect(() => {
    if (filterChange.baseStudy) {
      dispatch(fetchGeneralContestSpecialitiesListAction(filterChange.baseStudy))
    }

  }, [filterChange.baseStudy])

  const handleChange = (key: any, value: any, option?: any ) => {

    if(option?.customSpecialityIndex || option?.customSpecialityIndex == 0){
      handleChange("specialityIndex", option.customSpecialityIndex.toString())
      handleChange("qualification", null)
    }

    setFilterChange(prev => ({
      ...prev,
      [key]: value
    }))
  }

  const column = [
    {
      title: '№',
      fixed: 'left',
      width: "50px",
      render: (text: any, record: any, index: any) => {
        return index + 1
      }
    },
    {
      title: t("educationOrders:applicationNumber"),
      dataIndex: 'id',
      key: 'number',
      width: "120px",
      fixed: 'left',
      render: (text: any, record: any, index: any) => {
        return record.selectedSpeciality && record.selectedSpeciality.id
      }
    },
    {
      title: t("educationOrders:entrantFio"),
      fixed: 'left',
      render: (text: any, record: any, index: any) => {
        let fio = `${record.educationOrder && record.educationOrder.surname_entrant} ${record.educationOrder && record.educationOrder.name_entrant} ${record.educationOrder && record.educationOrder.patronymic_entrant}`

        return fio
      }
    },
    {
      title: t("educationOrders:applicationLanguage"),
      width: "60px",
      render: (text: any, record: any, index: any) => {
        return record.selectedSpeciality && (record.selectedSpeciality.language_of_education === 2 ? t("educationOrders:ru") :
          record.selectedSpeciality.language_of_education === 1 ? t("educationOrders:kz") :
            "-")
      }
    },
    {
      title: t("educationOrders:educationalBase"),
      render: (text: any, record: any, index: any) => {
        return record.educationOrder && (record.educationOrder.base_education === "1" ? t("educationOrders:baseSecondary") :
          record.educationOrder.base_education === "2" ? t("educationOrders:generalAverage") :
            record.educationOrder.base_education === "4" ? t("educationOrders:tipo") :
              record.educationOrder.base_education === "3" ? t("educationOrders:higherEducation") :
                "Выбранная образовательная база неверна")

        // <option value='1'>{t('stepTwo.selectedEntrant.basicEducation.basicMiddle')}</option>
        // <option value='2'>{t('stepTwo.selectedEntrant.basicEducation.generalMiddle')}</option>
        // <option value='3'>{t('stepTwo.selectedEntrant.basicEducation.tipo')}</option>
        // <option value='4'>{t('stepTwo.selectedEntrant.basicEducation.generalHigher')}</option>
      }
    },
    {
      title: t("educationOrders:specialty"),
      render: (text: any, record: any, index: any) => {
        return record.selectedSpeciality && record.selectedSpeciality.speciality && record.selectedSpeciality.speciality.caption
      }
    },
    {
      title: t("educationOrders:qualification"),
      render: (text: any, record: any, index: any) => {
        return record.selectedSpeciality && record.selectedSpeciality.qualification && record.selectedSpeciality.qualification.caption
      }
    },
    {
      title: t("educationOrders:priority"),
      render: (text: any, record: any, index: any) => {
        return record.selectedSpeciality && record.selectedSpeciality.priority
      }
    },
    {
      title: t("educationOrders:averageScoreOfTheCertificate"),
      width: '90px',
      render: (text: any, record: any, index: any) => {
        return record.average_rating
      }
    },
    {
      title: t("educationOrders:averageCompetitiveScore"),
      width: '90px',
      render: (text: any, record: any, index: any) => {
        return record.contest_rating
      }
    },
    {
      title: t("educationOrders:date"),
      width: '90px',
      render: (text: any, record: any, index: any) => {
        return record.selectedSpeciality.created_at && dayjs(record.selectedSpeciality.created_at).format('DD.MM.YY')
      }
    },
    {
      title: t("educationOrders:contacts"),
      width: '115px',
      render: (text: any, record: any, index: any) => {
        return record.educationOrder && record.educationOrder.phone_entrant
      }
    },
    {
      title: t("educationOrders:action"),
      render: (text: any, record: any, index: any) => {
        return (
          <Row justify='center' gutter={4} key={record.id}>
            {
              record.status === 1 && record.selectedSpeciality && record.selectedSpeciality.transfer && record.selectedSpeciality.transfer.status_confirm === 1 ?
                <>

                </>
                :
                record.status === 1 && record.selectedSpeciality && record.selectedSpeciality.transfer && record.selectedSpeciality.transfer.status_confirm === 0 ?
                  <>
                    <Tooltip title={t("educationOrders:awaitingConfirmation")}>
                      <IconTransferWaiting/>
                    </Tooltip>
                  </>
                  :
                  record.status === 1 && record.selectedSpeciality && record.selectedSpeciality.entrant_response === "1" ? (
                      <>
                        <Tooltip title={t("educationOrders:transferToAnotherCollege")}>
                          <p className="transferText" onClick={() => {
                            //@ts-ignore
                            dispatch(fetchCollegeListToTransferAction(record.selectedSpeciality.id))
                            handleModalVisible(true, 'transfer', record)
                          }}>{t("educationOrders:transfer")}</p>
                        </Tooltip>
                      </>
                    ) :
                    record.action ?
                      <>
                        <Col>
                          <Tooltip title={t("educationOrders:confirm")} placement='bottom'>
                            <Button type='text' icon={<IconAccept/>}
                                    onClick={() => handleModalVisible(true, 'accept', record)}/>
                          </Tooltip>
                        </Col>

                        <Col>
                          <Tooltip title={t("educationOrders:deny")} placement='bottom'>
                            <Button type='text' icon={<IconReject/>}
                                    onClick={() => handleModalVisible(true, 'reject', record)}/>
                          </Tooltip>
                        </Col>
                      </>
                      :
                      null
              // <Col>
              // 	<Tooltip title='Передать в другой колледж' placement='bottom'>
              // 		<Button type='text' onClick={() => handleModalVisible(true, 'transfer')}>
              // 			<Typography.Text style={{textDecoration: 'underline', color: '#1890FF'}}>
              // 				Передать
              // 			</Typography.Text>
              // 		</Button>
              // 	</Tooltip>
              // </Col>
            }
          </Row>
        )
      }
    }
  ]
  const columnTargetGrant = [
    {
      title: '№',
      fixed: 'left',
      width: "50px",
      render: (text: any, record: any, index: any) => {
        // Вычисляем индекс записи на основе текущей страницы и размера страницы
        return <Row>{(currentTargetGrantPagination - 1) * 10 + index + 1}</Row>
      }
    },
    {
      title: t("educationOrders:applicationNumber"),
      dataIndex: 'id',
      key: 'number',
      width: "120px",
      fixed: 'left',
      render: (text: any, record: any, index: any) => {
        return record.selectedSpeciality && record.selectedSpeciality.id
      }
    },
    {
      title: t("educationOrders:entrantFio"),
      fixed: 'left',
      render: (text: any, record: any, index: any) => {
        let fio = `${record.educationOrder && record.educationOrder.surname_entrant} ${record.educationOrder && record.educationOrder.name_entrant} ${record.educationOrder && record.educationOrder.patronymic_entrant}`

        return fio
      }
    },
    {
      title: t("educationOrders:applicationLanguage"),
      width: "60px",
      render: (text: any, record: any, index: any) => {
        return record.selectedSpeciality && (record.selectedSpeciality.language_of_education === 2 ? t("educationOrders:ru") :
          record.selectedSpeciality.language_of_education === 1 ? t("educationOrders:kz") :
            "-")
      }
    },
    {
      title: t("educationOrders:educationalBase"),
      render: (text: any, record: any, index: any) => {
        return record.educationOrder && (record.educationOrder.base_education === "1" ? t("educationOrders:educationalBase") :
          record.educationOrder.base_education === "2" ? t("educationOrders:baseSecondary") :
            record.educationOrder.base_education === "4" ? t("educationOrders:tipo") :
              record.educationOrder.base_education === "3" ? t("educationOrders:higherEducation") :
                "Выбранная образовательная база неверна")

        // <option value='1'>{t('stepTwo.selectedEntrant.basicEducation.basicMiddle')}</option>
        // <option value='2'>{t('stepTwo.selectedEntrant.basicEducation.generalMiddle')}</option>
        // <option value='3'>{t('stepTwo.selectedEntrant.basicEducation.tipo')}</option>
        // <option value='4'>{t('stepTwo.selectedEntrant.basicEducation.generalHigher')}</option>
      }
    },
    {
      title: t("educationOrders:specialty"),
      render: (text: any, record: any, index: any) => {
        return record.selectedSpeciality && record.selectedSpeciality.speciality && record.selectedSpeciality.speciality.caption
      }
    },
    {
      title: t("educationOrders:qualification"),
      render: (text: any, record: any, index: any) => {
        return record.selectedSpeciality && record.selectedSpeciality.qualification && record.selectedSpeciality.qualification.caption
      }
    },
    {
      title: t("educationOrders:date"),
      width: '90px',
      render: (text: any, record: any, index: any) => {
        return record.selectedSpeciality.created_at && dayjs(record.selectedSpeciality.created_at).format('DD.MM.YY')
      }
    },
    {
      title: t("educationOrders:contacts"),
      width: '115px',
      render: (text: any, record: any, index: any) => {
        return record.educationOrder && record.educationOrder.phone_entrant
      }
    },
    {
      title: t("educationOrders:action"),
      render: (text: any, record: any, index: any) => {
        return (
          <Row justify='center' gutter={4} key={record.id}>
            {
              (record.selectedSpeciality.entrant_response == "3") ?
                (<p style={{
                  textDecoration: "underline",
                  color: "#248841",
                  fontSize: 12,
                  lineHeight: "20px"
                }}>{t("educationOrders:accepted")}</p>
                ) : (
                  <Tooltip title={t("educationOrders:confirm")} placement='bottom'>
                  <Button type='text'
                          icon={<IconAccept/>}
                          onClick={() => handleModalVisible(true, 'targetGrant', record)}/>
                </Tooltip>
                )
            }
          </Row>
        )
      }
    }
  ]



  const filters = () => {

    const handleRenderContent = () => {
      switch (currentTab) {
        case "tab-item-2":
        case "tab-item-3":
          return (
            <>
              <Col span={12}>
                <Row>
                  <Col span={24}>
                    <Typography>
                      {t("educationOrders:specialty")}
                    </Typography>
                  </Col>

                  <Col span={24}>
                    <Select
                      onChange={(value: any, option: any) => handleChange("speciality", value)}
                      value={filterChange.speciality}
                      loading={specialities.loading}
                      disabled={!specialities.success}
                      showSearch
                      filterOption={(input, option) => {
                        const label = option?.label?.toLowerCase() || "";
                        const children = option?.children?.toString().toLowerCase() || "";
                        const searchText = input.toLowerCase();

                        return label.includes(searchText) || children.includes(searchText);
                      }}
                      style={{ width: '100%' }}
                    >
                      {specialities.data && specialities.data.length > 0 && specialities.data.map((item: any, index: any) => (
                        <Select.Option
                          value={item.id}
                          key={`${item.id}-${item.caption}-2-${index}`}
                          label={`${item.caption} - ${item.code}`} // Добавляем label для надежной фильтрации
                        >
                          {item.caption} - <strong>{item.code}</strong>
                        </Select.Option>
                      ))}
                    </Select>
                  </Col>
                </Row>
              </Col>
              {specialities.data && specialities.data.applicationsAmount > 0 ? (
                <Row style={{marginLeft: 8}} align="middle" className="dot-blinking">
                  <IconDiod/>
                </Row>
              ) : null}
            </>
          )

        case "tab-item-1":
        default:
          return (
            <>
              <Col span={12} style={{marginRight: 16}}>
                <Row>
                  <Col span={24}>
                    <Typography>
                      {t("educationOrders:specialty")}
                    </Typography>
                  </Col>

                  <Col span={24}>
                    <Select
                      onChange={(value: any, option: any) => handleChange("speciality", value)}
                      value={filterChange.speciality}
                      loading={specialities.loading}
                      disabled={!specialities.success}
                      showSearch
                      filterOption={(input, option) => {
                        const label = option?.label?.toLowerCase() || "";
                        const children = option?.children?.toString().toLowerCase() || "";
                        const searchText = input.toLowerCase();

                        return label.includes(searchText) || children.includes(searchText);
                      }}
                      style={{ width: '100%' }}
                    >
                      {specialities.data && specialities.data.length > 0 && specialities.data.map((item: any, index: any) => (
                        <Select.Option
                          value={item.id}
                          key={`${item.id}-${item.caption}-2-${index}`}
                          label={`${item.caption} - ${item.code}`} // Добавляем label для надежной фильтрации
                        >
                          {item.caption} - <strong>{item.code}</strong>
                        </Select.Option>
                      ))}
                    </Select>
                  </Col>
                </Row>
              </Col>
              {specialities.data && specialities.data.applicationsAmount > 0 ? (
                <Row style={{marginLeft: 8}} align="middle" className="dot-blinking">
                  <IconDiod/>
                </Row>
              ) : null}

              {/*<Col span={6}>*/}
              {/*  <Row>*/}
              {/*    <Col span={24}>*/}
              {/*      <Typography>Квалификации</Typography>*/}

              {/*      <Col span={24}>*/}
              {/*        <Select onChange={(value: any, option: any) => handleChange("qualification", value, option)}*/}
              {/*                value={filterChange.qualification}*/}
              {/*                loading={specialities.loading} disabled={!filterChange.speciality}*/}
              {/*                style={{width: '100%'}}>*/}
              {/*          {*/}
              {/*            //@ts-ignore*/}
              {/*            specialities.data && specialities.data.length > 0 && specialities?.data[filterChange?.specialityIndex]?.qualifications.map((item: any, index: any) => (*/}
              {/*                <Select.Option value={item.id}*/}
              {/*                               key={`${item.id}-${item.caption}-2-${index}-2`}>*/}
              {/*                  {`${item.caption} (${item.amount_bids})`}*/}
              {/*                </Select.Option>*/}
              {/*            ))*/}
              {/*          }*/}
              {/*        </Select>*/}
              {/*      </Col>*/}
              {/*    </Col>*/}
              {/*  </Row>*/}
              {/*</Col>*/}
              {/*{specialities.data && specialities.data.applicationsAmount > 0 ? (*/}
              {/*  <Row style={{marginLeft: 8}} align="middle" className="dot-blinking">*/}
              {/*    <IconDiod/>*/}
              {/*  </Row>*/}
              {/*) : null}*/}
            </>
          )
      }
    }


    return (
      <div style={{margin: '0 16px'}}>
        <StyledRow align='bottom' gutter={16} justify='space-between' style={{margin: '0 0 16px 0'}}>
          <Col span={15}>
            <Row>
              <Col span={7} style={{marginRight: 16}}>
                <Row>
                  <Typography>
                    {t("educationOrders:baseEducation")}
                  </Typography>

                  <Select onChange={(value, option) => handleChange("baseStudy", value)}
                          value={filterChange.baseStudy}
                          style={{width: '100%'}}>
                    {
                      baseStudyState.map((item, index) => (
                        <Select.Option value={item.value} key={index + "-test"}>
                          {item.name}
                        </Select.Option>
                      ))
                    }
                  </Select>
                </Row>
              </Col>

              {handleRenderContent()}
            </Row>
          </Col>

          <Col span={8}>

            <Row justify="end">

              <Col style={{marginRight: 16}}>
                <StyledButton style={{height: 40}} onClick={() => {
                  dispatch(fetchGeneralContestSpecialitiesListActionResets())
                  setFilterChange(initialFilterChange)
                }}>
                  {t("educationOrders:reset")}
                </StyledButton>
              </Col>

              <Col style={{marginRight: 16}}>
                <StyledButton onClick={handleCallGeneralContest} style={{height: 40}}>
                  Обновить
                </StyledButton>
              </Col>

              <Col>
                <StyledButton onClick={handleCallGeneralContest} style={{height: 40}} type='primary'>
                  {t("educationOrders:submit")}
                </StyledButton>
              </Col>
            </Row>
          </Col>

        </StyledRow>
      </div>
    )
  }

  const tableGeneralContest = () => {

    let clonedData = generalContest && generalContest.data && generalContest.data.length >= 1 ? [...generalContest.data] : []
    let filteredData = clonedData.filter((item) => {
      if (item.status != 2 && item.selectedSpeciality.entrant_response != 3) {
        return item
      }
    })


    return (
      <Row style={{margin: '0 16px', background: '#fff', padding: 16}}>
        <Col span={24}>
          {/*@ts-ignore*/}
          <Table columns={column}
                 dataSource={filteredData}
                 pagination={false}
                 bordered
                 rowClassName={record => record.status && record.selectedSpeciality &&
                   ((record.status === 1 && record.selectedSpeciality && !record.selectedSpeciality.entrant_response) ? "unclassified" :
                     (record.status === 1 && record.selectedSpeciality && record.selectedSpeciality.transfer && record.selectedSpeciality.transfer.status_confirm === 0) ? "transferred" :
                       (record.status === 1 && record.selectedSpeciality && record.selectedSpeciality.entrant_response === "1") ? "succeeded" :
                         (record.status === 3 && record.selectedSpeciality && record.selectedSpeciality.entrant_response === "2") ? "declined" :
                           (record.status === 3) ? "exclude" :
                             (record.status === 4) ? "inLine" :
                               "777")}
                 rowKey={record => record.id}
                 scroll={{x: 1000, y: 600}}
          />
        </Col>
      </Row>
    )
  }

  const tableTargetGrant = () => {

    let clonedData = generalContest && generalContest.data && generalContest.data.length >= 1 ? [...generalContest.data] : []
    let filteredData = clonedData.filter((item) => {
      if (item.selectedSpeciality.entrant_response == 3 || item.status == 2) {
        return item
      }
    })

    return (
      <Row style={{padding: 16, margin: "0 16px", background: '#fff'}}>
        <Col span={24} style={{marginBottom: 16}}>
          <Typography.Title level={5} style={{fontWeight: "700", fontSize: 16, lineHeight: "24px"}}>
            {t("educationOrders:targetGrant")}
          </Typography.Title>
        </Col>
        <Col span={24}>
          {/*@ts-ignore*/}
          <Table columns={columnTargetGrant}
                 dataSource={filteredData}
                 pagination={{position: ["bottomRight"], defaultPageSize: 10, onChange: (page:any, pageSize:any) => setCurrentTargetGrantPagination(page)}}
                 bordered
                 rowClassName={record => record.status && record.selectedSpeciality &&
                   (
                     (record.selectedSpeciality.entrant_response == 3) ? "succeeded"
                       : "")}
                 rowKey={record => record.id}
                 scroll={{x: 1000, y: 600}}
          />
        </Col>
      </Row>
    )
  }

  const tableGeneralContestWithQuotes = () => {

    return (
      <Row style={{margin: '0 16px', background: '#fff'}}>
        {generalContestWithQuotes?.success || generalContestWithQuotes?.loading ? (
          <>
            <Col span={24}>
              <Col span={24} style={{marginBottom: 16, marginTop: 20, paddingLeft: 16, paddingRight: 16}}>
                <Typography.Title level={5} style={{fontWeight: "700", fontSize: 16, lineHeight: "24px"}}>
                  {t("admission:stepOne.quota.listOfQuotes.children_many")}
                </Typography.Title>
              </Col>

              <Col span={24} style={{paddingLeft: 16, paddingRight: 16}}>
                {/*@ts-ignore*/}
                <Table columns={column}
                       dataSource={(generalContestWithQuotes?.data && generalContestWithQuotes.data.children_many && generalContestWithQuotes.data.children_many.length > 0) ? generalContestWithQuotes.data.children_many.filter((item:any) => item.selectedSpeciality.entrant_response != 3) : []}
                       pagination={false}
                       bordered

                       rowClassName={record => record.status && record.selectedSpeciality &&
                         ((record.status === 1 && record.selectedSpeciality && !record.selectedSpeciality.entrant_response) ? "unclassified" :
                           (record.status === 1 && record.selectedSpeciality && record.selectedSpeciality.transfer && record.selectedSpeciality.transfer.status_confirm === 0) ? "transferred" :
                             (record.status === 1 && record.selectedSpeciality && record.selectedSpeciality.entrant_response === "1") ? "succeeded" :
                               (record.status === 3 && record.selectedSpeciality && record.selectedSpeciality.entrant_response === "2") ? "declined" :
                                 (record.status === 3) ? "exclude" :
                                   (record.status === 4) ? "inLine" :
                                     "777")}
                       rowKey={record => record.id}
                />
              </Col>
              <Divider style={{height: '100%', border: '1px dashed #C2CFD6'}}/>
            </Col>
            <Col span={24}>
              <Col span={24} style={{marginBottom: 16, marginTop: 20, paddingLeft: 16, paddingRight: 16}}>
                <Typography.Title level={5} style={{fontWeight: "700", fontSize: 16, lineHeight: "24px"}}>
                  {t("admission:stepOne.quota.listOfQuotes.children_without_parent")}
                </Typography.Title>
              </Col>
              <Col span={24} style={{paddingLeft: 16, paddingRight: 16}}>
                {/*@ts-ignore*/}
                <Table columns={column}
                       dataSource={(generalContestWithQuotes?.data &&
                         generalContestWithQuotes.data.children_without_parent &&
                         generalContestWithQuotes.data.children_without_parent.length > 0)
                         ? generalContestWithQuotes.data.children_without_parent.filter((item:any) => item.selectedSpeciality.entrant_response != 3)
                         : []}
                       pagination={false}
                       bordered

                       rowClassName={record => record.status && record.selectedSpeciality &&
                         ((record.status === 1 && record.selectedSpeciality && !record.selectedSpeciality.entrant_response) ? "unclassified" :
                           (record.status === 1 && record.selectedSpeciality && record.selectedSpeciality.transfer && record.selectedSpeciality.transfer.status_confirm === 0) ? "transferred" :
                             (record.status === 1 && record.selectedSpeciality && record.selectedSpeciality.entrant_response === "1") ? "succeeded" :
                               (record.status === 3 && record.selectedSpeciality && record.selectedSpeciality.entrant_response === "2") ? "declined" :
                                 (record.status === 3) ? "exclude" :
                                   (record.status === 4) ? "inLine" :
                                     "777")}
                       rowKey={record => record.id}
                />
              </Col>
              <Divider style={{height: '100%', border: '1px dashed #C2CFD6'}}/>
            </Col>
            <Col span={24}>
              <Col span={24} style={{marginBottom: 16, marginTop: 20, paddingLeft: 16, paddingRight: 16}}>
                <Typography.Title level={5} style={{fontWeight: "700", fontSize: 16, lineHeight: "24px"}}>
                  {t("admission:stepOne.quota.listOfQuotes.faces_kaz_nac_without_rk")}
                </Typography.Title>
              </Col>
              <Col span={24} style={{paddingLeft: 16, paddingRight: 16}}>
                {/*@ts-ignore*/}
                <Table columns={column}
                       dataSource={(generalContestWithQuotes?.data && generalContestWithQuotes?.data?.faces_kaz_nac_without_rk && generalContestWithQuotes.data.faces_kaz_nac_without_rk.length > 0) ? generalContestWithQuotes.data.faces_kaz_nac_without_rk.filter((item:any) => item.selectedSpeciality.entrant_response != 3) : []}
                       pagination={false}
                       bordered

                       rowClassName={record => record.status && record.selectedSpeciality &&
                         ((record.status === 1 && record.selectedSpeciality && !record.selectedSpeciality.entrant_response) ? "unclassified" :
                           (record.status === 1 && record.selectedSpeciality && record.selectedSpeciality.transfer && record.selectedSpeciality.transfer.status_confirm === 0) ? "transferred" :
                             (record.status === 1 && record.selectedSpeciality && record.selectedSpeciality.entrant_response === "1") ? "succeeded" :
                               (record.status === 3 && record.selectedSpeciality && record.selectedSpeciality.entrant_response === "2") ? "declined" :
                                 (record.status === 3) ? "exclude" :
                                   (record.status === 4) ? "inLine" :
                                     "777")}
                       rowKey={record => record.id}
                />
              </Col>
              <Divider style={{height: '100%', border: '1px dashed #C2CFD6'}}/>
            </Col>
            <Col span={24}>
              <Col span={24} style={{marginBottom: 16, marginTop: 20, paddingLeft: 16, paddingRight: 16}}>
                <Typography.Title level={5} style={{fontWeight: "700", fontSize: 16, lineHeight: "24px"}}>
                  {t("admission:stepOne.quota.listOfQuotes.family_half")}
                </Typography.Title>
              </Col>

              <Col span={24} style={{paddingLeft: 16, paddingRight: 16}}>
                {/*@ts-ignore*/}
                <Table columns={column}
                       dataSource={(generalContestWithQuotes?.data && generalContestWithQuotes?.data?.family_half && generalContestWithQuotes.data.family_half.length > 0) ? generalContestWithQuotes.data.family_half.filter((item:any) => item.selectedSpeciality.entrant_response != 3) : []}
                       pagination={false}
                       bordered

                       rowClassName={record => record.status && record.selectedSpeciality &&
                         ((record.status === 1 && record.selectedSpeciality && !record.selectedSpeciality.entrant_response) ? "unclassified" :
                           (record.status === 1 && record.selectedSpeciality && record.selectedSpeciality.transfer && record.selectedSpeciality.transfer.status_confirm === 0) ? "transferred" :
                             (record.status === 1 && record.selectedSpeciality && record.selectedSpeciality.entrant_response === "1") ? "succeeded" :
                               (record.status === 3 && record.selectedSpeciality && record.selectedSpeciality.entrant_response === "2") ? "declined" :
                                 (record.status === 3) ? "exclude" :
                                   (record.status === 4) ? "inLine" :
                                     "777")}
                       rowKey={record => record.id}
                />
              </Col>
              <Divider style={{height: '100%', border: '1px dashed #C2CFD6'}}/>
            </Col>
            <Col span={24}>
              <Col span={24} style={{marginBottom: 16, marginTop: 20, paddingLeft: 16, paddingRight: 16}}>
                <Typography.Title level={5} style={{fontWeight: "700", fontSize: 16, lineHeight: "24px"}}>
                  {t("admission:stepOne.quota.listOfQuotes.family_with_invalid")}
                </Typography.Title>
              </Col>

              <Col span={24} style={{paddingLeft: 16, paddingRight: 16}}>
                {/*@ts-ignore*/}
                <Table columns={column}
                       dataSource={(generalContestWithQuotes.data && generalContestWithQuotes.data.family_with_invalid && generalContestWithQuotes.data.family_with_invalid.length > 0) ? generalContestWithQuotes.data.family_with_invalid.filter((item:any) => item.selectedSpeciality.entrant_response != 3) : []}
                       pagination={false}
                       bordered

                       rowClassName={record => record.status && record.selectedSpeciality &&
                         ((record.status === 1 && record.selectedSpeciality && !record.selectedSpeciality.entrant_response) ? "unclassified" :
                           (record.status === 1 && record.selectedSpeciality && record.selectedSpeciality.transfer && record.selectedSpeciality.transfer.status_confirm === 0) ? "transferred" :
                             (record.status === 1 && record.selectedSpeciality && record.selectedSpeciality.entrant_response === "1") ? "succeeded" :
                               (record.status === 3 && record.selectedSpeciality && record.selectedSpeciality.entrant_response === "2") ? "declined" :
                                 (record.status === 3) ? "exclude" :
                                   (record.status === 4) ? "inLine" :
                                     "777")}
                       rowKey={record => record.id}
                />
              </Col>
              <Divider style={{height: '100%', border: '1px dashed #C2CFD6'}}/>
            </Col>
            <Col span={24}>
              <Col span={24} style={{marginBottom: 16, marginTop: 20, paddingLeft: 16, paddingRight: 16}}>
                <Typography.Title level={5} style={{fontWeight: "700", fontSize: 16, lineHeight: "24px"}}>
                  {t("admission:stepOne.quota.listOfQuotes.invalid1and2")}
                </Typography.Title>
              </Col>

              <Col span={24} style={{paddingLeft: 16, paddingRight: 16}}>
                {/*@ts-ignore*/}
                <Table columns={column}
                       dataSource={(generalContestWithQuotes?.data && generalContestWithQuotes?.data?.invalid1and2 && generalContestWithQuotes.data.invalid1and2.length > 0) ? generalContestWithQuotes.data.invalid1and2.filter((item:any) => item.selectedSpeciality.entrant_response != 3) : []}
                       pagination={false}
                       bordered

                       rowClassName={record => record.status && record.selectedSpeciality &&
                         ((record.status === 1 && record.selectedSpeciality && !record.selectedSpeciality.entrant_response) ? "unclassified" :
                           (record.status === 1 && record.selectedSpeciality && record.selectedSpeciality.transfer && record.selectedSpeciality.transfer.status_confirm === 0) ? "transferred" :
                             (record.status === 1 && record.selectedSpeciality && record.selectedSpeciality.entrant_response === "1") ? "succeeded" :
                               (record.status === 3 && record.selectedSpeciality && record.selectedSpeciality.entrant_response === "2") ? "declined" :
                                 (record.status === 3) ? "exclude" :
                                   (record.status === 4) ? "inLine" :
                                     "777")}
                       rowKey={record => record.id}
                />
              </Col>
              <Divider style={{height: '100%', border: '1px dashed #C2CFD6'}}/>
            </Col>
            <Col span={24}>
              <Col span={24} style={{marginBottom: 16, marginTop: 20, paddingLeft: 16, paddingRight: 16}}>
                <Typography.Title level={5} style={{fontWeight: "700", fontSize: 16, lineHeight: "24px"}}>
                  {t("admission:stepOne.quota.listOfQuotes.village_rk")}
                </Typography.Title>
              </Col>

              <Col span={24} style={{paddingLeft: 16, paddingRight: 16}}>
                {/*@ts-ignore*/}
                <Table columns={column}
                       dataSource={(generalContestWithQuotes?.data && generalContestWithQuotes?.data?.village_rk && generalContestWithQuotes.data.village_rk.length > 0) ? generalContestWithQuotes.data.village_rk.filter((item:any) => item.selectedSpeciality.entrant_response != 3) : []}
                       pagination={false}
                       bordered

                       rowClassName={record => record.status && record.selectedSpeciality &&
                         ((record.status === 1 && record.selectedSpeciality && !record.selectedSpeciality.entrant_response) ? "unclassified" :
                           (record.status === 1 && record.selectedSpeciality && record.selectedSpeciality.transfer && record.selectedSpeciality.transfer.status_confirm === 0) ? "transferred" :
                             (record.status === 1 && record.selectedSpeciality && record.selectedSpeciality.entrant_response === "1") ? "succeeded" :
                               (record.status === 3 && record.selectedSpeciality && record.selectedSpeciality.entrant_response === "2") ? "declined" :
                                 (record.status === 3) ? "exclude" :
                                   (record.status === 4) ? "inLine" :
                                     "777")}
                       rowKey={record => record.id}
                />
              </Col>
              <Divider style={{height: '100%', border: '1px dashed #C2CFD6'}}/>
            </Col>
            <Col span={24}>
              <Col span={24} style={{marginBottom: 16, marginTop: 20, paddingLeft: 16, paddingRight: 16}}>
                <Typography.Title level={5} style={{fontWeight: "700", fontSize: 16, lineHeight: "24px"}}>
                  {t("admission:stepOne.quota.listOfQuotes.village_soc_ek")}
                </Typography.Title>
              </Col>

              <Col span={24} style={{paddingLeft: 16, paddingRight: 16}}>
                {/*@ts-ignore*/}
                <Table columns={column}
                       dataSource={(generalContestWithQuotes?.data && generalContestWithQuotes?.data?.village_soc_ek && generalContestWithQuotes.data.village_soc_ek.length > 0) ? generalContestWithQuotes.data.village_soc_ek.filter((item:any) => item.selectedSpeciality.entrant_response != 3) : []}
                       pagination={false}
                       bordered

                       rowClassName={record => record.status && record.selectedSpeciality &&
                         ((record.status === 1 && record.selectedSpeciality && !record.selectedSpeciality.entrant_response) ? "unclassified" :
                           (record.status === 1 && record.selectedSpeciality && record.selectedSpeciality.transfer && record.selectedSpeciality.transfer.status_confirm === 0) ? "transferred" :
                             (record.status === 1 && record.selectedSpeciality && record.selectedSpeciality.entrant_response === "1") ? "succeeded" :
                               (record.status === 3 && record.selectedSpeciality && record.selectedSpeciality.entrant_response === "2") ? "declined" :
                                 (record.status === 3) ? "exclude" :
                                   (record.status === 4) ? "inLine" :
                                     "777")}
                       rowKey={record => record.id}
                />
              </Col>
              <Divider style={{height: '100%', border: '1px dashed #C2CFD6'}}/>
            </Col>
            <Col span={24}>
              <Col span={24} style={{marginTop: 20, paddingLeft: 16, paddingRight: 16}}>
                <Typography.Title level={5} style={{fontWeight: "700", fontSize: 16, lineHeight: "24px"}}>
                  {t("admission:stepOne.quota.listOfQuotes.vov")}
                </Typography.Title>
              </Col>

              <Col span={24} style={{paddingLeft: 16, paddingRight: 16, marginBottom: 16}}>
                {/*@ts-ignore*/}
                <Table columns={column}
                       dataSource={(generalContestWithQuotes?.data && generalContestWithQuotes?.data?.vov && generalContestWithQuotes.data.vov.length > 0) ? generalContestWithQuotes.data.vov.filter((item:any) => item.selectedSpeciality.entrant_response != 3) : []}
                       pagination={false}
                       bordered
                       rowClassName={record => record.status && record.selectedSpeciality &&
                         ((record.status === 1 && record.selectedSpeciality && !record.selectedSpeciality.entrant_response) ? "unclassified" :
                           (record.status === 1 && record.selectedSpeciality && record.selectedSpeciality.transfer && record.selectedSpeciality.transfer.status_confirm === 0) ? "transferred" :
                             (record.status === 1 && record.selectedSpeciality && record.selectedSpeciality.entrant_response === "1") ? "succeeded" :
                               (record.status === 3 && record.selectedSpeciality && record.selectedSpeciality.entrant_response === "2") ? "declined" :
                                 (record.status === 3) ? "exclude" :
                                   (record.status === 4) ? "inLine" :
                                     "777")}
                       rowKey={record => record.id}
                />
              </Col>
              <Divider style={{height: '100%', border: '1px dashed #C2CFD6'}}/>
            </Col>
            <Col span={24}>
              <Col span={24} style={{marginBottom: 16, marginTop: 20, paddingLeft: 16, paddingRight: 16}}>
                <Typography.Title level={5} style={{fontWeight: "700", fontSize: 16, lineHeight: "24px"}}>
                  {t("admission:stepOne.quota.listOfQuotes.conscript")}
                </Typography.Title>
              </Col>

              <Col span={24} style={{paddingLeft: 16, paddingRight: 16, marginBottom: 16}}>
                {/*@ts-ignore*/}
                <Table columns={column}
                       dataSource={(generalContestWithQuotes?.data && generalContestWithQuotes?.data?.conscript && generalContestWithQuotes.data.conscript.length > 0) ? generalContestWithQuotes.data.conscript.filter((item:any) => item.selectedSpeciality.entrant_response != 3) : []}
                       pagination={false}
                       bordered
                       rowClassName={record => record.status && record.selectedSpeciality &&
                         ((record.status === 1 && record.selectedSpeciality && !record.selectedSpeciality.entrant_response) ? "unclassified" :
                           (record.status === 1 && record.selectedSpeciality && record.selectedSpeciality.transfer && record.selectedSpeciality.transfer.status_confirm === 0) ? "transferred" :
                             (record.status === 1 && record.selectedSpeciality && record.selectedSpeciality.entrant_response === "1") ? "succeeded" :
                               (record.status === 3 && record.selectedSpeciality && record.selectedSpeciality.entrant_response === "2") ? "declined" :
                                 (record.status === 3) ? "exclude" :
                                   (record.status === 4) ? "inLine" :
                                     "777")}
                       rowKey={record => record.id}
                />
              </Col>
            </Col>
          </>
        ) : null}
      </Row>
    )
  }

  const tabsItems = [
    {
     key: "tab-item-1",
     label: t("educationOrders:generalCompetition"),
     children: <>
       {filters()}
       {tableGeneralContest()}
     </>
    },
    {
      key: "tab-item-2",
      label: t("educationOrders:byQuotes"),
      children: <>
        {filters()}
        {tableGeneralContestWithQuotes()}
      </>
    },
    {
      key: "tab-item-3",
      label: t("educationOrders:targetGrant"),
      children: <>
        {filters()}
        {tableTargetGrant()}
      </>
    },
  ]

  const handleTabsChange = (key: string) => {

    dispatch(fetchGeneralContestSpecialitiesListActionResets())
    setFilterChange(initialFilterChange)

    setCurrentTab(key)
  }

  return (
    <>
      <MyBreadcrumb title={t("educationOrders:ranging")} isFullStack isBack link={`${process.env.REACT_APP_FULLSTACK_URL}${redirect ? redirect : "/education-order/work-by-executor"}`}/>
      <Row justify='center'>
        <Col span={20}>
          <Row>
            <Col span={24} style={{marginTop: 16}}>
              <StyledEducationOrdersContainer>
                <div style={{display: 'flex', flexDirection: 'column', height: '100%'}}>
                  <Tabs items={tabsItems} onChange={handleTabsChange}/>
                </div>

                <AcceptModal initialVisibleState={initialModalState} visible={modalState.accept}
                             setVisible={setModalState}
                             data={data}/>
                <RejectModal initialVisibleState={initialModalState} visible={modalState.reject}
                             setVisible={setModalState}
                             data={data}/>
                <TransferModal initialVisibleState={initialModalState} visible={modalState.transfer}
                               setVisible={setModalState}
                               data={data}/>
                <TargetGrantModal initialVisibleState={initialModalState} visible={modalState.targetGrant}
                                  setVisible={setModalState}
                                  data={data}/>
              </StyledEducationOrdersContainer>
            </Col>
          </Row>
        </Col>
      </Row>

    </>

  )
}